import type { RejectedProps } from './types';

export const Rejected: React.FC<RejectedProps> = ({ title, text, label, onRejectedGoBack }) => {
  return (
    <div>
      <h1 className="text-black">{title}</h1>
      <div className="Base-container">
        <div>{text}</div>
      </div>
      <div className="flex flex-row flex-wrap border-none justify-end items-baseline w-full my-2.5">
        <button
          type="button"
          className="ml-10 inline-block cursor-pointer rounded-[30px] border border-black bg-white px-10 py-2.5 text-[15px] font-normal uppercase tracking-wide text-accent outline-none my-2.5"
          onClick={onRejectedGoBack}
        >
          {label}
        </button>
      </div>
    </div>
  );
};
